import { TrainingClass } from './training.class';
import { TrainingEventSubscriptionArray } from './training.event.subscription';
import { EmailLogResponseArray } from '../ss-api/responses/email.log.response';

export class TrainingEvent {
    ID: number;
    Created: Date;
    Modified: Date;
    AttendeeCount: number;
    CheckedInAttendeeCount: number;
    EventDateTime: Date;
    TrainingClassID: number;
    TrainingClass: TrainingClass;
    Attendees: TrainingEventSubscriptionArray;
    TrainerID: number;
    TrainerName: string;
    TrainerEmail: string;
    GoToMeetingLink: string;
    WebinarID: string;

    EmailLogs: EmailLogResponseArray;

    public static FixDates(item: TrainingEvent) {
        item.Created = new Date(item.Created);
        item.Modified = new Date(item.Modified);
        item.EventDateTime = new Date(item.EventDateTime);
    }

}

export class TrainingEventArray extends Array<TrainingEvent> {

    constructor(...items: TrainingEvent[]) {
        super(...items);
        Object.setPrototypeOf(this, TrainingEventArray.prototype);
    }

    public static FixDates(item: TrainingEventArray) {
        item.forEach(x => TrainingEvent.FixDates(x));
    }


}
